import "./panda-assistant-icon.css";

export function PandaAssistantIcon({ className = "" }: { className?: string }) {
  return <span className={`panda-assistant-icon ${className}`} aria-hidden="true">
    <svg viewBox="840 315 790 825" focusable="false">
      <image href="/yida-panda-assistant.jpg" width={2362} height={1359} />
    </svg>
  </span>;
}
